import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Trash2 } from "lucide-react";

export default function CommittentiPage() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");

  const load = async () => setItems((await api.get("/committenti")).data);
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!name.trim()) return;
    try { await api.post("/committenti", { name, code }); toast.success(t("auto.committente_creato")); setName(""); setCode(""); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  const del = async (id) => {
    if (!window.confirm("Eliminare?")) return;
    try { await api.delete(`/committenti/${id}`); load(); } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Anagrafica</div>
        <h1 className="mt-1 text-3xl font-bold text-slate-900 lg:text-4xl">{t("menu.clients")}</h1>
      </div>

      <div className="rounded-sm border border-slate-200 bg-white p-5">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
          <div><Label>{t("common.name")}</Label><Input value={name} onChange={(e) => setName(e.target.value)} placeholder="es. Vodafone" className="rounded-sm" data-testid="committente-name" /></div>
          <div><Label>{t("common.code")}</Label><Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="es. VF" className="rounded-sm font-mono" data-testid="committente-code" /></div>
          <div className="flex items-end"><Button onClick={create} className="rounded-sm bg-[#0052FF] hover:bg-[#0040CC]" data-testid="committente-add"><Plus className="mr-2 h-4 w-4" /> {t("auto.aggiungi")}</Button></div>
        </div>
      </div>

      <div className="overflow-x-auto rounded-sm border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="border-b border-slate-200 bg-slate-50 text-left text-xs font-bold uppercase tracking-widest text-slate-500">
            <tr><th className="p-3">{t("common.name")}</th><th className="p-3">{t("common.code")}</th><th className="p-3 text-right">{t("common.actions")}</th></tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="p-3 font-medium">{c.name}</td>
                <td className="p-3 font-mono">{c.code || "—"}</td>
                <td className="p-3 text-right"><Button size="sm" variant="ghost" onClick={() => del(c.id)}><Trash2 className="h-4 w-4 text-red-600" /></Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
